import styled from 'styled-components'

import { minmedia, maxmedia } from '../../styles/media-queries'
import { white, whitegray } from '../../styles/colors'

export const OuterWrap = styled.div`
  position: relative;
  z-index: -1;
  overflow: hidden; // Edge fix

  ${minmedia.medium`
    padding-bottom: 1rem; // prevent title from being cut off by overflow:hidden
  `};
`

export const Wrap = styled.div`
  width: 100%;
  position: relative;

  &::before {
    content: '';
    display: block;
    height: ${props => (props.setsize === 'small' ? '80px' : props.title ? '200px' : '130px')};

    ${minmedia.medium`
      height: ${props => (props.setsize === 'small' ? '100px' : props.title ? '280px' : '200px')};
    `};
    ${minmedia.xmlarge`
      height: ${props => (props.setsize === 'small' ? '140px' : props.title ? '550px' : '350px')};
    `};
  }
`

export const Background = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
  font-family: 'object-fit: cover; object-position: center center;';
`

export const ContentContainer = styled.div`
  width: 92%;
  max-width: 1600px;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
`

export const Content = styled.div`
  position: absolute;
  bottom: 1.5rem;
  max-width: 125px;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${white};
  text-align: left;
  line-height: 0.9;

  ${minmedia.medium`
    bottom: auto;
    top: 50%;
    transform: translateY(-50%);
    font-size: 36px;
    max-width: 175px;
  `};
  ${minmedia.xmlarge`
    top: 55%;
    font-size: 72px;
    max-width: 400px;
  `};
`

export const TitleContainer = styled.div`
  ${maxmedia.medium`
    text-align: center;
    position: ${props => (props.title ? 'relative' : 'absolute')}
    top: ${props => (props.title ? 'auto' : '50%')}
    left: ${props => (props.title ? 'auto' : '50%')}
    transform: ${props => (props.title ? 'none' : 'translate(-50%, -50%)')};
    color: ${props => (props.title ? '#000' : '#fff')};
    padding: ${props => (props.title ? '1.5rem 1.5rem 0 1.5rem' : '0')};
  `};
  ${minmedia.medium`
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 500px;
    background: ${whitegray};
    padding: 1.5rem;
    padding-bottom: 0;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    text-align: center;
  `};
`

export const Title = styled.h1`
  font-family: 'Trocchi', sans-serif;
  font-weight: 400;
  font-size: 24px;
  margin-bottom: 0;

  ${minmedia.medium`
    font-size: 28px;
    margin-bottom: -9px;
  `} ${minmedia.xmlarge`
    font-size: 32px;
  `};
`



// WEBPACK FOOTER //
// ./src/components/Hero/styles.js